import styled from "styled-components";
import { colors, typography } from "@streeteasy/design-system";
import Tooltip from "@streeteasy/design-system/legacy/Tooltip";

export const AddToCalendarContainer = styled.div`
  align-items: center;
  display: flex;
`;

export const AddToCalendarCTA = styled(typography.Caps)`
  color: ${colors.BRAND};
`;

export const StyledTooltip = styled(Tooltip)`
  padding-right: 10px;

  [class*="styled__TooltipContent"] {
    padding: 10px 24px;
  }

  span {
    &::before {
      color: white;
      font-size: 37px;
    }
  }
`;
